/**
 * Order Gate permissions — InternalEntity capability only.
 */

export const ORDER_GATE_READ_PERMISSION = 'order_gate:read' as const;
export const ORDER_GATE_OVERRIDE_PERMISSION = 'order_gate:override' as const;

export const ORDER_GATE_PERMISSIONS = [
  ORDER_GATE_READ_PERMISSION,
  ORDER_GATE_OVERRIDE_PERMISSION,
] as const;

export type OrderGatePermission = (typeof ORDER_GATE_PERMISSIONS)[number];

export function isOrderGatePermission(permission: string): permission is OrderGatePermission {
  return (ORDER_GATE_PERMISSIONS as readonly string[]).includes(permission);
}
